export default function diffInPercent(current, previous) {
  if (current === 0 && previous === 0) return '0'
  if ((previous > current && current === 0) || (previous < current && previous === 0)) {
    return '100'
  }

  return Math.floor(Math.max(current, previous) / Math.min(current, previous))
}
